export default "__VITE_ASSET__298fa304__"